import React, { useState } from 'react'

import { useEffect, useContext } from 'react'

import mobGifList from '../../../../data/Monsters/npcidentity.json'

import { DBContext } from '../../../../contexts/databases'

import './monsterWindow.scss'

function MonsterWindow(props) {
	const { monster_db, monster_dbReady } = useContext(DBContext)

	const [options, setOptions] = useState([])
	const [currentMob, setCurrentMob] = useState(Number(0))
	try {
		useEffect(() => {
			let newOptions = []
			// newOptions.push(
			// 	<option value='0' key='mob0' label='No Monster'></option>
			// )
			if (monster_dbReady) {
				monster_db.forEach((mob, index) => {
					newOptions.push(
						<option
							value={index}
							key={'mob' + mob.Id}
							label={mob.Name}
						></option>
					)
				})
				setOptions(newOptions)
			}
		}, [monster_db, monster_dbReady])
	} catch (e) {
		console.log(e)
	}

	return (
		<div className={'monsterWindow'}>
			<div className='monsterWindowHorizontal'>
				<select
					name='Monster'
					id='Monster'
					onChange={(event) => {
						setCurrentMob(event.target.value)
						props.onMonsterSelect(monster_db[event.target.value])
					}}
				>
					{options}
				</select>
			</div>
			{monster_dbReady ? (
				<div className='monsterWindowHorizontal'>
					{/* <div className='monsterWindowVertical'> */}
					<div className='imageDiv'>
						<img
							src={
								'https://images.roprime-simulator.com/npc/' +
								(mobGifList[monster_db[currentMob].Id]
									? mobGifList[
											monster_db[currentMob].Id
									  ].toLowerCase()
									: 'null') +
								'.gif'
							}
							alt={monster_db[currentMob].Name}
						></img>
						{/* </div> */}
					</div>
					<div className='monsterWindowVertical'>
						{/* {console.log(monster_db[currentMob])} */}
						<div>Level : {monster_db[currentMob].Level}</div>
						<div>HP : {monster_db[currentMob].Hp}</div>
						<div>Size : {monster_db[currentMob].Size}</div>
						<div>Race : {monster_db[currentMob].Race}</div>
						<div>Element : {monster_db[currentMob].Element}</div>
						<div>
							Element Level :{' '}
							{monster_db[currentMob].ElementLevel}
						</div>
					</div>
				</div>
			) : (
				'loading db'
			)}

			<div className={'monsters ' + props.className}></div>
		</div>
	)
}

export default MonsterWindow
